import React from 'react';
import {ArrowIcon} from 'icons';
import FollowStrategy from 'components/Cards/Strategy/components/FollowStrategy';
import NavBar from '../NavBar';

export const renderSubMenu = (location, {followingStrategiesCount}) => {
  const {pathname, state} = location;

  if (pathname.includes('/p/')) {
    return null;
  }

  if (pathname.includes('/s/')) {
    return (
      <NavBar
        nav={[
          {url: '/strategies', icon: <ArrowIcon />, className: 'strategy-type'},
          {title: 'Overview', url: {pathname: `/s/${state.strategy.id}`, state: {strategy: state.strategy}}},
          {
            title: 'Last 10 picks',
            url: {pathname: `/s/${state.strategy.id}/last-picks`, state: {strategy: state.strategy}},
          },
        ]}
      >
        {state && <FollowStrategy strategy={state.strategy} />}
      </NavBar>
    );
  }
  if (pathname.includes('/strategies')) {
    return (
      <NavBar
        nav={[
          {title: 'Explore', url: '/strategies'},
          {title: `Following Strategies (${followingStrategiesCount})`, url: '/strategies/following'},
        ]}
      />
    );
  }
  if (pathname.includes('/payments/')) {
    return (
      <NavBar
        nav={[{url: '/account/payments', title: 'Payments', icon: <ArrowIcon />, className: 'back-to-payments'}]}
      />
    );
  }
  if (pathname.includes('/account')) {
    return (
      <NavBar
        nav={[
          {title: 'Profile', url: '/account'},
          {title: 'Payments', url: '/account/payments'},
        ]}
      />
    );
  }
  if (pathname.includes('/stats')) {
    return <NavBar nav={[{title: 'Settled Favorites', url: '/stats/settled'}]} />;
  }
  return null;
};
